import { render, staticRenderFns } from "./ServiceRecipe.vue?vue&type=template&id=f68bea9e&scoped=true&"
import script from "./ServiceRecipe.vue?vue&type=script&lang=js&"
export * from "./ServiceRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68bea9e",
  null
  
)

export default component.exports